import { queryKeys } from '@/api/query-keys'
import { portraitsService } from '@/api/services/portraits.service'
import { type PortraitListQueryOptions, usePortraitListQuery } from './use-portrait-list-query'

/** The job's grades for the Grade dropdown, in the order the API returns them. */
export function usePortraitGradesQuery({ enabled }: PortraitListQueryOptions = {}) {
  return usePortraitListQuery({
    queryKey: queryKeys.portraits.grades(),
    queryFn: () => portraitsService.getGrades(),
    enabled,
  })
}
